export const kindLabels = { foundation: 'Data foundation', conventional: 'Conventional improvement', governance: 'Governance', measurement: 'Measurement & review', ai: 'AI solution' };

export function canRequestQuote(item, roadmap) {
  if (!item?.quote_available || item.availability === 'deferred') return false;
  if (item.kind !== 'ai') return ['foundation', 'conventional', 'governance', 'measurement'].includes(item.kind);
  return !!item.goal_ids?.length && item.goal_ids.every(id => roadmap?.goal_decisions?.some(d => d.goal_id === id && d.decision === 'proceed_now'));
}

export function validContact(email, mobile) {
  const digits = mobile.replace(/\D/g, '');
  return email.trim().length <= 254 && /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>.]+$/.test(email.trim())
    && /^\+?[\d\s()-]{10,40}$/.test(mobile.trim()) && /^[1-9]\d{9,14}$/.test(digits);
}

export function apiError(error, fallback) {
  return typeof error?.response?.data?.detail === 'string' ? error.response.data.detail : fallback;
}
